<template>
  <div>
    <TopBar title="Evaluation"/>
    <div class="page-content">
      <div class="container">
        <div class="box">
          <img src="../../assets/nps.png" alt="">
          <br> <br>
          <div class="text-center mt-3">
            <p class="text-dark mb-0">Vous devez avoir bénéficié d'un service complet pour avoir accès au questionnaire de satisfaction.</p>
            <br>
            <router-link :to="{name: 'home-page'}" href="javascript:void(0);" class="btn btn-primary">Passer une commande <i class="fa-solid fa-angle-right ms-2"></i></router-link>
          </div>
        </div>
      </div>

<!--      <div class="footer fixed ">
        <div class="container">
          <p class="text-dark text-center">Your Order Number is <span class="font-w600">223455</span></p>
          <div class="footer-btn d-flex align-items-center">
            <a href="tracking-order2.html" class="btn btn-primary flex-1 ms-2">Order Delivery Status</a>
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script setup>
import {onMounted} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";


onMounted(() => {

})
</script>

<style scoped>
.footer.fixed {
  bottom: 59px;
}

.payment-box{
  background-image: url("../../assets/bg-shape.png");
}
.btn-link{
  color: var(--primary);
}

.payment-box .payment-successful i{
  background: var(--primary);
}
.payment-box {
  height: 150px;
}
</style>